var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05272 5.1439C3.9939 5.22064 3.91821 5.2828 3.8315 5.32559C3.7448 5.36837 3.64941 5.39062 3.55272 5.39062C3.45603 5.39062 3.36065 5.36837 3.27394 5.32559C3.18724 5.2828 3.11154 5.22064 3.05272 5.1439L0.252721 1.8939C0.144865 1.77781 0.0695728 1.6353 0.0344542 1.48078C-0.000664356 1.32626 0.00563754 1.1652 0.0527214 1.0139C0.0943102 0.871701 0.179341 0.746074 0.295901 0.654619C0.412461 0.563164 0.554711 0.510463 0.702722 0.503899L6.35272 0.5039C6.50031 0.511909 6.64186 0.56515 6.75815 0.656391C6.87444 0.747632 6.95983 0.872452 7.00272 1.0139C7.05447 1.16125 7.06785 1.31936 7.04161 1.47331C7.01536 1.62727 6.95036 1.77201 6.85272 1.8939L4.05272 5.1439Z",
    fill: "#0084FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBlue);
export default __webpack_public_path__ + "static/media/chevron-down-blue.99654f9da7fe47ae6db2f4d1be2883c5.svg";
export { ForwardRef as ReactComponent };